import { useState, useEffect } from "react";
import { Outlet } from "react-router-dom";
import styles from "../style.module.scss";
import getCommercial from "../../../util/getCommercial";
import { Row, Col } from "react-bootstrap";
import HeaderGroup from "../../../components/HeaderGroup";
import MenuGroup from "../../../components/MenuGroup";

export default function GroupLayout() {
  const [commercialId, setcommercialId] = useState(null);
  useEffect(() => {
    let _pathname;
    if (window.location.pathname.includes("/groups/") && !window.location.pathname.includes("/costs/")) {
      _pathname = window.location.pathname.split("/");
      setcommercialId(parseInt(_pathname[2]));
    }
  }, [window.location]);

  const [reload, setreload] = useState(false);
  const [commercial, setcommercial] = useState(null);

  useEffect(() => {
    if (commercialId) {
      setcommercial(null);
      getCommercial(commercialId).then(response => {
        setcommercial(response);
      });
    }
  }, [reload, commercialId]);

  return (
    <>
      <Row>
        <Col>
          <Outlet context={{ commercial, reload, setreload }} />
        </Col>
        <Col sm={3} className="-hide-on-print">
          <MenuGroup commercial={commercial} reload={reload} setreload={setreload} />
        </Col>
      </Row>
    </>
  );
}
